module.exports = __webpack_public_path__ + "static/img/200215.357d31d1.png";